import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {Step} from '../models/consultation/Step';

@Injectable({
    providedIn: 'root'
})
export class ConsultationService {

    // region Public Methods

    onUpdateSurveyStep: Subject<Step> = new Subject<Step>();
    onUpdateSurveyQuestion: Subject<any> = new Subject<any>();

    // endregion

    // Update Survey Data
    updateSurveyQuestion(data: any, question: any) {

        this.onUpdateSurveyQuestion.next({data, question});

    }

    // Update Survey Step
    updateSurveyStep(step: Step): void {

        this.onUpdateSurveyStep.next(step);

    }

}
